{
  "enum": {
    "IxcTradereportingV1BlueSheetStatus": {
      "ARCHIVED": "Archived",
      "GENERATED": "Generated",
      "REPORTED": "Reported",
      "REQUESTED": "Requested",
      "UNSPECIFIED": "Unspecified"
    },
    "IxcTradereportingV1CaisReportStatus": {
      "ERROR": "Error",
      "GENERATED": "Generated",
      "PENDING": "Pending",
      "PROCESSING": "Processing",
      "SUBMITTED": "Submitted",
      "UNSPECIFIED": "Unspecified"
    },
    "IxcTradereportingV1CatReportStatus": {
      "ERROR": "Error",
      "GENERATED": "Generated",
      "PENDING": "Pending",
      "PROCESSING": "Processing",
      "SUBMITTED": "Submitted",
      "UNSPECIFIED": "Unspecified"
    },
    "IxcTradereportingV1Sec606AReportStatus": {
      "ACCEPTED": "Accepted",
      "ERRORED": "Errored",
      "GENERATED": "Generated",
      "PROCESSING": "Processing",
      "PUBLISHED": "Published",
      "REJECTED": "Rejected",
      "SUBMITTED": "Submitted",
      "SUPERSEDED": "Superseded",
      "UNSPECIFIED": "Unspecified"
    }
  },
  "filterEnum": {
    "IxcTradereportingV1BlueSheetQueryServiceBlueSheetListFilterableFields": {
      "reportId": "Report",
      "status": "Status"
    },
    "IxcTradereportingV1CaisReportQueryServiceCaisReportListFilterableFields": {
      "reportId": "Report",
      "status": "Status"
    },
    "IxcTradereportingV1CatReportQueryServiceCatReportListFilterableFields": {
      "reportId": "Report",
      "status": "Status"
    },
    "IxcTradereportingV1OrderBlotterServiceRecordListFilterableFields": {
      "account": {
        "summary": {
          "registration": {
            "profile": {
              "naturalPersons": {
                "others": {
                  "w9": {
                    "signed": "Others W-9 Signed"
                  }
                },
                "person": {
                  "w9": {
                    "signed": "Person W-9 Signed"
                  }
                }
              },
              "organization": {
                "w9": {
                  "signed": "Organization W-9 Signed"
                }
              }
            }
          }
        }
      },
      "order": {
        "accountId": "Account",
        "data": {
          "asset": {
            "assetId": "Asset",
            "data": {
              "category": "Category",
              "type": {
                "!type": "Order Type",
                "equity": {
                  "controls": {
                    "canBuy": "Equity: Can Buy",
                    "canEnterFractions": "Equity: Can Enter Fractions",
                    "canSell": "Equity: Can Sell"
                  },
                  "cusip": "Order Equity CUSIP"
                },
                "moneyMarket": {
                  "classification": "Money Market: Classification",
                  "controls": {
                    "canBuy": "Money Market: Can Buy",
                    "canEnterFractions": "Money Market: Can Enter Fractions",
                    "canSell": "Money Market: Can Sell"
                  },
                  "cusip": "Order Money Market CUSIP",
                  "navType": "Money Market: NAV Type"
                }
              }
            },
            "status": "Order Status"
          },
          "batchOrderId": "Batch Order",
          "holdId": "Order Hold",
          "instruction": {
            "side": "Order Instruction Side"
          }
        },
        "orderId": "Order",
        "programId": "Program",
        "status": "Order Status"
      }
    },
    "IxcTradereportingV1Sec606AReportQueryServiceSec606AReportListFilterableFields": {
      "data": {
        "quarter": "Data Quarter",
        "year": "Data Year"
      },
      "reportId": "Report ID",
      "status": "Status"
    }
  },
  "oneOf": {
    "IxcTradereportingV1BlueSheetEventType": {
      "archived": "Archived",
      "created": "Created",
      "generated": "Generated",
      "reported": "Reported"
    },
    "IxcTradereportingV1CaisReportEventType": {
      "created": "Created",
      "failed": "Failed",
      "generated": "Generated",
      "processingStarted": "Processing Started",
      "submitted": "Submitted"
    },
    "IxcTradereportingV1CatReportEventType": {
      "created": "Created",
      "failed": "Failed",
      "generated": "Generated",
      "processingStarted": "Processing Started",
      "submitted": "Submitted"
    },
    "IxcTradereportingV1Sec606AReportEventType": {
      "accepted": "Accepted",
      "created": "Created",
      "generated": "Generated",
      "generationFailed": "Generation Failed",
      "published": "Published",
      "rejected": "Rejected",
      "submitted": "Submitted",
      "superseded": "Superseded"
    }
  },
  "searchEnum": {
    "IxcTradereportingV1OrderBlotterServiceRecordListSearchableFields": {
      "account": {
        "displayId": "Display ID",
        "summary": {
          "registration": {
            "profile": {
              "naturalPersons": {
                "others": {
                  "nameDetails": {
                    "first": "First Name",
                    "last": "Last Name"
                  }
                },
                "person": {
                  "nameDetails": {
                    "first": "First Name",
                    "last": "Last Name"
                  }
                }
              }
            }
          }
        }
      },
      "order": {
        "data": {
          "asset": {
            "data": {
              "type": {
                "equity": {
                  "name": "Equity: Name",
                  "symbol": {
                    "base": "Equity: Symbol"
                  }
                },
                "moneyMarket": {
                  "name": "Money Market: Name",
                  "symbol": {
                    "base": "Money Market: Symbol"
                  }
                }
              }
            }
          }
        }
      }
    }
  },
  "sortEnum": {
    "IxcTradereportingV1BlueSheetQueryServiceBlueSheetListSortableFields": {
      "metadata": {
        "createdAt": "Created At",
        "updatedAt": "Updated At"
      }
    },
    "IxcTradereportingV1CaisReportQueryServiceCaisReportListSortableFields": {
      "metadata": {
        "createdAt": "Created At",
        "updatedAt": "Updated At"
      }
    },
    "IxcTradereportingV1CatReportQueryServiceCatReportListSortableFields": {
      "metadata": {
        "createdAt": "Created At",
        "updatedAt": "Updated At"
      }
    },
    "IxcTradereportingV1OrderBlotterServiceRecordListSortableFields": {
      "order": {
        "data": {
          "asset": {
            "metadata": {
              "createdAt": "Order Created At",
              "updatedAt": "Order Updated At"
            }
          }
        },
        "metadata": {
          "createdAt": "Order Created At",
          "updatedAt": "Order Updated At"
        }
      }
    },
    "IxcTradereportingV1Sec606AReportQueryServiceSec606AReportListSortableFields": {
      "data": {
        "quarter": "Quarter",
        "year": "Year"
      },
      "metadata": {
        "createdAt": "Created At",
        "updatedAt": "Updated At"
      }
    }
  }
}